import Vendor from './Vendor'

export default Vendor

